<template>
  <div>
     <!--PARITE NEWSLETTER DESKTOP-->
     <div class="mt-5" style="background: rgba(153,153,153,0.39);height: auto" v-responsive.lg.xl>
        <div class="pt-5 pb-3 row margin">
          <div class="justify-content-center row ml-0">
            <h1 class="justify-content-center row newsletter_titre_desktop">{{
                $t('home_page.newsletter_title')
                }}</h1>
                <a href="https://www.221assurances.com" target="_blank">
                <img class="mt-1 ml-4" src="../../assets/img/logos_sn_221.png" alt="logos_sn_221" style="width: 50px;cursor: pointer;">
                </a>
          </div>

          <div class="justify-content-center row" style="padding-left: 8%">
            <input v-model="email" type="email" name="email" id="email_input"
                    :placeholder="$t('home_page.newsletter_input_placeholder')">
          </div>
          <div class="justify-content-center row" style="margin-left: 8%">
            <!-- <button style="height: 50px!important" flat class="newsletter" @click="suscribeNewsletter()">
              <span class="newsletter">{{ $t('home_page.newsletter_bouton') }}</span>
            </button> -->

            <button style="height: 50px!important" flat class="newsletter" @click="suscribeNewsletter221()">
              <span class="newsletter">{{ $t('home_page.newsletter_bouton') }}</span>
            </button>
          </div>
        </div>
      </div>
      <!--PARITE PAIEMENT DESKTOP-->


        <!--PARITE NEWSLETTER MOBILE-->
        <v-layout v-responsive.sm.xs>
        <div style="background: rgba(153,153,153,0.39);height:auto;width: 100%">
          <div class="justify-content-center column">
            <div class="pt-5 justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{$t('home_page.newsletter_title')}}</h1>
            </div>

            <div class="justify-content-center row">
              <a href="https://www.221assurances.com" target="_blank">
                <img class="mt-3 mb-4" src="../../assets/img/logos_sn_221.png" alt="logos_sn_221" style="width: 50px;cursor: pointer;">
                </a>
            </div>

            <div class="mt-2 justify-content-center row">
              <input v-model="email" type="email" name="email" id="email_input" :placeholder="$t('home_page.newsletter_input_placeholder')">
            </div>

            <div class="justify-content-center row pb-5">
              <button style="height: 50px!important" flat class="newsletter ml-2" @click="suscribeNewsletter221()">
                <span class="newsletter">{{$t('home_page.newsletter_bouton')}}</span>
              </button>
            </div>
          </div>
        </div>
      </v-layout>
    <!--FIN PARITE NEWSLETTER MOBILE-->
  </div>

    <!-- <div class="newsletters">
      <h1 class="label-newsletter">{{ $t('home_page.newsletter_title') }}</h1>
      <input v-model="userEmail" class="field-suscribe" type="email" name="email" id="email_input" :placeholder="$t('home_page.newsletter_input_placeholder')">
      <button class="suscribe" @click="suscribeNewsletter">{{ $t('home_page.newsletter_bouton') }}</button>
    </div> -->
</template>
  
<script>
import ToastMixin from '../../mixin/ToastMixin';
import { newsletterController } from '../../services/newsletter/newsletter.controller';
import dayjs from 'dayjs';
import PushInDataLayer from '../../services/TagManager';
import ApiBrevo from '../../services/ApiBrevo';

  export default {
    name: 'NewsletterAssurancePart',
    mixins: [ToastMixin],
    data() {
        return {
            email: '',
            ToastTabSucess: {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 4000,
              fitToScreen: true,
              type: 'success',
              className: 'custom-success-class'
            }, // Customized options for success toast
            ToastTabError: {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 4000,
              fitToScreen: true,
              type: 'error'
            },
        }
    },
    methods: {
      suscribeNewsletter221 () {
        if(this.email) {
          let newAbonne221 = {
            listIds: [23],
            email: this.email,
            updateEnabled: false
          }

          ApiBrevo().post('contacts', newAbonne221)
            .then(result => {
              console.log("result===== ", result)

              if (result.status === 201) {
                this.$toasted.show("Merci de votre inscription à notre newsletter 221 !", this.ToastTabSucess);
                this.email = ''
              }
            }).catch((err) => {
              console.log("err==== ", err)
              this.$toasted.show("Le mail saisit est déja inscrit dans notre newsletter", this.ToastTabError);
            }); 
        } else {
          this.$toasted.show("Un email valide est obligatoire pour souscrire à notre newsletter 221 !", this.ToastTabError);
        }        
        },

        suscribeNewsletter () {
          let newAbonne = {
            user: "",
            etat: "enabled",
            FNAME: "",
            LNAME: "",
            PHONE: "",
            email: this.userEmail,
            dateAbone: dayjs(new Date()).format('YYYY-MM-DD')
          }
          
          if(this.$store.state.isUserLoggedIn) {
            newAbonne.user = this.$store.state.user._id
            newAbonne.FNAME = this.$store.state.user.prenom
            newAbonne.LNAME = this.$store.state.user.nom
            newAbonne.PHONE = this.$store.state.user.telephone_port
          } 

          newsletterController.suscribe(newAbonne) 
          .then((result) => {
            const GtmVal = {
              event:'newsletter_subscription'
            }
            PushInDataLayer(GtmVal)
            this.$toasted.show(result.data.msg, this.ToastTabSucess);
            this.UserEmail = ''
          })
          .catch((error) => {
            this.$toasted.show(error.message, this.ToastTabError)
          })
        }
    }
  }
</script>
  
<style scoped>
  .newsletters {
    display: flex;
    align-items: center;
    background-color: rgba(153,153,153,0.39);
    height: 150px;
    padding: 0px 8%;
  }
  .field-suscribe {
    background-color: hsla(0, 0%, 45.1%, .58);
    height: 50px;
    font-size: 16px;
    /* border: 2px solid #000; */
    border-radius: 10px;
    padding: 10px 15px;
    width: 300px;
    color: #fff;
    outline: 0;
    margin-left: 9%;
  }
  .field-suscribe::placeholder {
    color: #fff;
    font-size: 20px;
  }
  .suscribe {
    width: 200px;
    font-weight: bold;
    font-size: 16px;
    height: 50px;
    border: 2px solid #000;
    border-radius: 10px;
    margin-left: 7%;
  }

  .label-newsletter {
    color: #001b19;
  }

  @media only screen and (max-width: 700px){
    .newsletters {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 180px;
      gap: 7px;
      /* padding: 5px 0; */
    }
    .field-suscribe {
      display: inline-block;
    }
  }





.newsletter span{
  width: 200px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  text-transform: none;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border: 2px solid #000000;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}
.newsletter:hover span {
  /*min-width: 220px;*/
  border-radius: 10px;
  border: none;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #000000;
  background: #ffa409;
}


input[type="email"]{
  background: rgba(255, 255, 255, 0.1);
  border: none;
  font-size: 16px;
  height: auto;
  margin: 0;
  outline: 0;
  padding: 15px;
  width: 300px;
  background-color: rgba(115, 115, 115, 0.58);
  color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
  margin-bottom: 30px;
}
input[type="email"]::placeholder{
  color: #fff;
  font-size: 20px;
}

.titre_for_desktop {
    color: #2b2b2b;
    font-size: 25px;
    font-weight: bold;
    text-align: center;
  }
  
  .newsletter_titre_desktop {
    color: #2b2b2b;
    font-size: 25px;
    font-weight: bold;
    margin-top: 6%;
    text-align: center;
  }
.margin {
    margin-left: 9.5%;
    margin-right: 9.5%;
  }
  
  .margin_mobile {
    margin-left: 5%;
    margin-right: 5%;
  }

  .margin-titre {
    margin-top: 48px;
    padding-bottom: 48px;
  }
  
</style>